var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 25,
    viewBox: "0 0 40 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3383 24.9064C19.1495 24.9064 24.671 19.3328 24.671 12.4574C24.671 5.58193 19.1495 0.00830078 12.3383 0.00830078C5.52716 0.00830078 0.00561523 5.58193 0.00561523 12.4574C0.00561523 19.3328 5.52716 24.9064 12.3383 24.9064Z",
    fill: "#EE0005"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6608 24.9064C34.472 24.9064 39.9935 19.3328 39.9935 12.4574C39.9935 5.58193 34.472 0.00830078 27.6608 0.00830078C20.8497 0.00830078 15.3281 5.58193 15.3281 12.4574C15.3281 19.3328 20.8497 24.9064 27.6608 24.9064Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3281 12.4573C15.3281 16.4101 17.1535 19.9323 19.9995 22.2127C22.8454 19.9322 24.6709 16.4101 24.6709 12.4573C24.6709 8.50445 22.8455 4.98228 19.9995 2.7019C17.1536 4.98247 15.3281 8.50455 15.3281 12.4573Z",
    fill: "#FF6300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMcard);
export default __webpack_public_path__ + "static/media/icon-mcard.4127207f.svg";
export { ForwardRef as ReactComponent };